// Vue instances
import Header from '@vue-instances/Header';

// Modules (don't need to lazy load)
import stickyHeader from '@modules/stickyHeader';
import initDynamicAccountButtons from '@modules/initDynamicAccountButtons';

export default async function init() {
  // Vue instances
  Header();

  // Modules
  stickyHeader();
  await initDynamicAccountButtons();
}
